import { reactive } from 'vue';
import { Mutations } from './Mutations';
import { Getters } from './Getters';
import { IState } from './IState';
import { ApplicationState } from '@/platform/ApplicationState';
import { Actions } from './Actions';

const state: IState = reactive<IState>({
	applicationState: ApplicationState.IDLE,
	destinationCountryId: null,
	originCountryId: null,
	visa: null,
});

const getters = new Getters(state);
const mutations = new Mutations(state);
const actions = new Actions(getters, mutations);

const store = { getters, actions };

export { store as GlobalStore };
